<div class="flex flex-wrap mt-8 mb-6">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (canManageAlbums()) {
            <app-btn-action label="New Album" (clicked)="onNewAlbum()" bgColor="bg-primary-500" textColor="text-white"
                icon="fa fa-add"></app-btn-action>
            }
        </div>
    </div>

    <div class="border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            Albums
        </h1>
    </div>

    <div class="w-full my-4">

        @let loadingAlbums = loadingAlbums$ | async;

        <div class="w-full flex flex-col gap-4">

            @for (item of albums$ | async; track item.id) {
            <div class="bg-white shadow-lg rounded w-full px-4 py-3">
                <div class="cursor-default flex flex-col gap-1">
                    <div class="flex flex-row items-start justify-between gap-4 w-full">
                        <a class="flex flex-col justify-start">
                            <p class="text-primary-300 text-xs whitespace-nowrap">
                                {{ item.albumDate | moment: 'Do MMM YYYY' }}
                            </p>
                            <div class="flex flex-col items-start gap-1">
                                <span [routerLink]="[item.id]" class="cursor-pointer font-semibold">
                                    {{ item.albumName }}
                                </span>
                                <p [routerLink]="[item.id]" class="cursor-pointer text-xs text-primary-300 font-light">
                                    {{ item.description }}
                                </p>
                            </div>
                        </a>
                        <div class="flex flex-row gap-2 whitespace-nowrap">
                            @if(canManageAlbums()) {
                            <app-btn-fab (click)="onAddImages(item)" icon="fas fa-add" [position]="btnFabPosition"
                                tooltip="Add Image(s)"></app-btn-fab>
                            <app-btn-fab (click)="onEditAlbum(item)" icon="fas fa-edit" [position]="btnFabPosition"
                                tooltip="Edit Album"></app-btn-fab>
                            <!-- <app-btn-fab (click)="onDeleteAlbum(item)" icon="fa fa-trash-can" [position]="btnFabPosition"
                                colors="bg-gray-100 text-red-500" tooltip="Delete"></app-btn-fab> -->
                            }
                        </div>
                    </div>
                </div>
            </div>
            } @empty {
            @if(!loadingAlbums) {
            <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                No Albums Found
            </div>
            }
            }
            @if(loadingAlbums) {
            <loading-card></loading-card>
            }
        </div>

        @if(!loadingAlbums) {
        <div class="flex flex-row w-full justify-center px-4 mt-3">
            <app-btn-more (click)="addMoreAlbums()"
                [isDisabled]="loadingAlbums || user?.uid == null || groupId == null"></app-btn-more>
        </div>
        }
    </div>